import type { AdminHostingRelease } from '../firebase';
import { toCsv } from '../csv';

const HEADERS = [
  'releaseId',
  'type',
  'status',
  'releaseTime',
  'releaseUserEmail',
  'message',
  'versionName',
  'fileCount',
  'versionBytes',
];

/** null → celda vacía; el resto se serializa con String(). */
function cell(value: string | number | null): string {
  if (value === null) {
    return '';
  }
  return String(value);
}

/** Genera el CSV del historial de deployments (releases de Hosting). */
export function buildDeploymentsCsv(releases: AdminHostingRelease[]): string {
  const rows = releases.map((r) => [
    cell(r.releaseId),
    cell(r.type),
    cell(r.status),
    cell(r.releaseTime),
    cell(r.releaseUserEmail),
    cell(r.message),
    cell(r.versionName),
    cell(r.fileCount),
    cell(r.versionBytes),
  ]);
  return toCsv(HEADERS, rows);
}
